/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActivityManifestEntry
 */
export interface ActivityManifestEntry {
    /**
     * Stable id referenced by attempts and artifacts.
     */
    key: string;
    /**
     * 
     */
    title: string;
    /**
     * Advisory to the frontend. The backend does not enforce grouping.
     */
    mode?: ActivityManifestEntryModeEnum;
    /**
     * 
     */
    order: number;
    /**
     * 
     */
    enabled: boolean;
    /**
     * Per-activity configuration — command palette, difficulty, anything the frontend needs.
     */
    config?: { [key: string]: any; };
}


/**
 * @export
 */
export const ActivityManifestEntryModeEnum = {
    Solo: 'solo',
    Pair: 'pair',
} as const;
export type ActivityManifestEntryModeEnum = typeof ActivityManifestEntryModeEnum[keyof typeof ActivityManifestEntryModeEnum];


/**
 * Check if a given object implements the ActivityManifestEntry interface.
 */
export function instanceOfActivityManifestEntry(value: object): value is ActivityManifestEntry {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function ActivityManifestEntryFromJSON(json: any): ActivityManifestEntry {
    return ActivityManifestEntryFromJSONTyped(json, false);
}

export function ActivityManifestEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityManifestEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'title': json['title'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'order': json['order'],
        'enabled': json['enabled'],
        'config': json['config'] == null ? undefined : json['config'],
    };
}

export function ActivityManifestEntryToJSON(json: any): ActivityManifestEntry {
    return ActivityManifestEntryToJSONTyped(json, false);
}

export function ActivityManifestEntryToJSONTyped(value?: ActivityManifestEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'title': value['title'],
        'mode': value['mode'],
        'order': value['order'],
        'enabled': value['enabled'],
        'config': value['config'],
    };
}

